import axios from "axios";
import { getBaseURL } from "@/app/global-functions/baseURLUtils-professors";

const baseURL = getBaseURL();
let currentDomain = "";

// Get the current domain
if (typeof window !== "undefined") {
  currentDomain = window.location.hostname;
}

// Create the axios instance
const axiosInstance = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-type": "application/json",
    "Accept": "application/json",
    "Content-Security-Policy": `default-src 'self' ${baseURL}; script-src 'self' 'unsafe-inline';`,
    "X-App-Domain": currentDomain,
  },
  withCredentials: true, // Allow sending cookies with cross-origin requests
});

// Add a request interceptor to include the Authorization header dynamically
axiosInstance.interceptors.request.use(
  (config) => {

    const token = localStorage.getItem("authToken"); // Retrieve token from localStorage or cookies
  
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
     console.log(error);

    return Promise.reject(error);
  }
);

export default axiosInstance;